export function getQueryParam<T = string>(
  query: T[] | T | undefined
): T | undefined {
  if (query) {
    if (Array.isArray(query)) {
      const lastItemIndex = query?.length > 0 ? query?.length - 1 : 0;
      return query?.[lastItemIndex];
    }
    return query;
  }
  return undefined;
}
